<template>
  <Benefit>
    {{ i18n(with5g ? translations.labelWith5g : translations.labelWithout5g) }}
  </Benefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Benefit from '../Benefit/Benefit.vue'

import translations from './CallsAndSmsUnlimitedTowardsFrance.translations'

defineProps<{ with5g: boolean }>()

const i18n = useI18n()
</script>
